import { Button } from '@cyberpion/cyberpion-ui';

export function MSSPLoginButton(props: any) {
  return (
    <a href={`/pages/dashboard/?account=${props.params.row.name}`} target="_blank" rel="noreferrer">
      <Button text="Login" type="button" buttonStyle="secondary" size="small" onClick={() => {}} />
    </a>
  );
}
